<template>
  <div class="slide">


    <div class="textArea">
      <div class="title">{{this.slideData[this.selectedSlide].title}}</div>
      <div class="summary">
        <div style="margin-bottom: 15px;">{{this.slideData[this.selectedSlide].summary}}
        </div>
        <ul>
          <li v-for="item in this.slideData[this.selectedSlide].points"> {{item}}</li>
        </ul>
      </div>
    </div>

    <div class="imageArea">
      <div v-if="this.slideData[this.selectedSlide].type != 'video'" class="imageContainer">
        <img height="739px" :src="this.slideData[this.selectedSlide].image">
      </div>
      <div v-if="slideData[this.selectedSlide].type == 'video'" class="imageContainer">
        <vid-component style="height: 740px" :video-prop="{ url: slideData[this.selectedSlide].url, poster: slideData[this.selectedSlide].poster}"></vid-component>
      </div>
      <div   class="controls">
        <div v-for="(slide, ind) in this.slideData">
          <button :class="btnClass(ind)" v-on:click="changeView(ind)">{{ slideData[ind].title }}</button>
        </div>
<!--        <button :class="btnClass(2)" v-on:click="changeView(2)">Process Performance</button>-->
<!--        <button :class="btnClass(3)" v-on:click="changeView(3)">What Are The Main Defects?</button>-->
      </div>
    </div>
  </div>
</template>

<script>

import VidComponent from "@/components/VidComponent";
export default {
name: "SlidesComponent.vue",
  data() {
  return {
    selectedSlide: 1
  }
  },
  props:{
  slideData: {}
  },
  methods: {
    changeView(sid){
      this.selectedSlide = sid;
     },
    btnClass(btn){
      if(this.selectedSlide == btn){
        return 'btn-outline-primary btn-active';
      }
      else {
        return 'btn-outline-primary';
      }
    }
  },
  components:{
  VidComponent
  }
}
</script>

<style scoped>
.slide{
  display: flex;
  flex-direction: row;
  flex: auto;

}
.textArea{
  display: flex;
  flex-direction: column;
  margin-right: 50px;
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .textArea{
    flex: 1 1 30%;
  }
}
.imageArea{
  display: flex;
  flex-direction: column;
  flex: 1 0 75%;
}
.imageContainer{
  border: 1px solid grey;
  margin: 0 25px;
}
.title{
  color: #271BCB;
  font-size: 28px;
  margin-bottom:30px;
}
.controls{
  margin-top: 60px;
  display: flex;
  flex-direction: row;
  margin-left: 30px;
  justify-content: flex-start;
  align-items: center;
}
.btn-active{
  color: white;
  background: #007bff;

}
.fade-enter-active, .fade-leave-active {
  transition: opacity 500ms;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.3;
}
.summary {  
  font-size: 20px;
  }
</style>